import { cn } from "@gymflow/helpers";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { ReactNode } from "react";

export function Breadcrumbs({
  pages,
  activeIdx = 0,
}: {
  pages: {
    icon?: ({ className }: { className?: string }) => ReactNode;
    name: string;
  }[];
  activeIdx?: number;
}) {
  return (
    <nav aria-label="Breadcrumb" className="flex">
      <ol className="flex items-center">
        {pages.map((page, idx) => {
          const Icon = page.icon;
          return (
            <li key={page.name}>
              <div className="flex items-center">
                {idx !== 0 && (
                  <ChevronRightIcon
                    aria-hidden="true"
                    className="mx-2 size-5 shrink-0 text-gray-400 dark:text-gray-400"
                  />
                )}
                <div
                  className={cn(
                    "text-secondary-600 flex items-center gap-1.5 rounded-lg border border-gray-200 px-3 py-2 text-sm font-semibold dark:border-gray-600 dark:text-gray-400",
                    {
                      "text-secondary-700 dark:bg-secondary-600 bg-secondary-25 dark:text-secondary-25":
                        activeIdx === idx,
                    },
                  )}
                >
                  {Icon && (
                    <Icon
                      className={cn(
                        "stroke-secondary-600 dark:stroke-gray-400",
                        {
                          "stroke-secondary-700 dark:stroke-secondary-25":
                            activeIdx === idx,
                        },
                      )}
                    />
                  )}
                  <div className="">{`${idx + 1}. ${page.name}`}</div>
                </div>
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
